module.exports = __webpack_public_path__ + "img/questionnaire-orange.0f4a3b4b.svg";